import React from 'react';
import { connect } from 'react-redux';
import { GetHealthCounselors } from '../../Services/Actions';
import history from '../../history';

import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { DataGrid } from '@mui/x-data-grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';

import WeekMonthPicker from '../../Components/WeekMonthPicker';

import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

const healthCounselorsColumns = [
    { field: 'DHCId', headerName: 'DHCId', flex: 0 },
    { field: 'DisplayName', headerName: 'Health counselor', flex: 3 },
    { field: 'TotalHours', headerName: 'Total hours', flex: 1,
        valueFormatter: params => {
            return new Intl.NumberFormat('no-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(params)
        }
    },
    { field: 'TotalClients', headerName: 'Total clients', flex: 1 },
    { field: 'TotalSalary', headerName: 'Total salary', flex: 1,
        valueFormatter: params => {
            return new Intl.NumberFormat('no-NO', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(params)
        }
    }
];

const pageSizeOptions = [ 10, 25, 50, { value: -1, label: 'All' } ];

class DHCsComponent extends React.Component {
    state = {
        DHCs: [],
        PageNo: 0,
        PageSize: -1,
        TotalRecords: 0,

        Sorting: [{
            field: 'DisplayName',
            sort: 'asc'
        }],

        SortingMode: 'server',

        EndDate: dayjs().endOf('month'), // isoWeek
        StartDate: dayjs().startOf('month'), // isoWeek

        SelectedDate: dayjs(),
        SelectedDate_Type: 'week',

        ShowCalendar: false
    }

    componentDidMount() {
        // // Get URL params for default data search
        //     const params = new URLSearchParams(window.location.search);
        //     let PageNo = params.get('page') || this.state.PageNo;
        //     let PageSize = params.get('pageSize') || this.state.PageSize;
        //     let SortCol = params.get('sortcol') || this.state.Sorting[0].field;
        //     let SortDir = params.get('sortdir') || this.state.Sorting[0]['sort'];
        //     let StartDate = params.get('startdate') ? dayjs(params.get('startdate')) : this.state.StartDate;
        //     let EndDate = params.get('enddate') ? dayjs(params.get('enddate')) : this.state.EndDate;

        // this.setState({ PageNo, PageSize, Sorting: [{ field: SortCol, sort: SortDir }], StartDate, EndDate }, () => this.onLoadHealthCounselors({}));

        this.onLoadHealthCounselors({});
    }

    onAdjustStartEndDates = () => {
        var { SelectedDate, SelectedDate_Type, StartDate, EndDate } = this.state;
    
        var date = dayjs(SelectedDate);
        var NewStartDate = SelectedDate_Type === 'week' ? date.startOf('isoWeek') : date.startOf('month');
        var NewEndDate = SelectedDate_Type === 'week' ? date.endOf('isoWeek') : date.endOf('month');
    
        if (!NewStartDate.isSame(StartDate) || !NewEndDate.isSame(EndDate)) {
            this.setState({ StartDate: NewStartDate, EndDate: NewEndDate }, () => this.onLoadHealthCounselors({}));
        }
    }

    onChangeSelectedDate_Type = event => {
        this.setState({ SelectedDate_Type: event.target.value }, () => this.onAdjustStartEndDates());
    }

    onClickDHC = ({ row }) => {
        history.push(`/dhc/${row.DHCId}`);
    }

    onLoadHealthCounselors = ({ page: PageNo, pageSize: PageSize }) => {
        PageNo = PageNo !== undefined ? PageNo : this.state.PageNo;
        PageSize = PageSize !== undefined ? PageSize : this.state.PageSize;

        PageNo++;

        var { EndDate, Sorting, StartDate } = this.state;

        EndDate = EndDate.format('YYYY-MM-DD');
        StartDate = StartDate.format('YYYY-MM-DD');

        if (Sorting.length) var { field: SortCol, sort: SortDir } = Sorting[0];

        // Update the URL query parameters
        // const params = new URLSearchParams(window.location.search);
        // params.set('page', PageNo);
        // params.set('pageSize', PageSize);
        // params.set('sortcol', SortCol);
        // params.set('sortdir', SortDir);
        // params.set('startdate', StartDate);
        // params.set('enddate', EndDate);
        // window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);

        this.props.GetHealthCounselors({ EndDate, PageNo, PageSize, SortCol, SortDir, StartDate }).then(({ DHCs, TotalRecords }) => {
            var SortingMode = (PageSize === -1 || (DHCs.length >= TotalRecords)) ? 'client' : 'server';
            this.setState({ DHCs, SortingMode, TotalRecords });
        })
    }

    onSelectNewDate = SelectedDate => {
        this.setState({ SelectedDate }, () => this.onAdjustStartEndDates());
    }

    onSortColumns = data => {
        this.setState({ Sorting: [ ...data ] }, () => {
            if (this.state.SortingMode === 'server') this.onLoadHealthCounselors({});
        });
    }

    onToggleShowCalendar = event => {
        this.setState({ ShowCalendar: event.target.checked });
    }

    onUpdatePaginationModel = ({ page, pageSize }) => {
        this.setState({ PageNo: page, PageSize: pageSize }, () => this.onLoadHealthCounselors({}));
    }

    renderDatePicker = () => {
        var { EndDate, SelectedDate, SelectedDate_Type, ShowCalendar, StartDate } = this.state;

        return (
            <>
                <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Switch checked={ShowCalendar} onChange={this.onToggleShowCalendar} name="show" />}
                            label="Show Calendar?"
                        />
                    </FormGroup>
                </Stack>

                {
                    !ShowCalendar ?
                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                        <Typography variant="h5">{dayjs(StartDate).format('DD/MM/YYYY')} - {dayjs(EndDate).format('DD/MM/YYYY')}</Typography>
                    </Stack>
                :
                    <>
                        <Box sx={{ height: 20 }} />

                        <WeekMonthPicker OnSelectNewDate={this.onSelectNewDate} SelectedDate={SelectedDate} SelectedDate_Type={SelectedDate_Type} />

                        <FormControl
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center', // Ensures label is centered
                            }}
                        >
                            <RadioGroup
                                row
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={SelectedDate_Type}
                                onChange={this.onChangeSelectedDate_Type}
                            >
                                <FormControlLabel value="week" control={<Radio />} label="Week" />
                                <FormControlLabel value="month" control={<Radio />} label="Month" />
                            </RadioGroup>
                        </FormControl>
                    </>
                }
            </>
        );
    }

    renderHealthCounselorsTable = () => {
        var { DHCs, PageNo, PageSize, SortingMode, TotalRecords } = this.state;

        return (
            <DataGrid
                rows={DHCs}
                columns={healthCounselorsColumns}
                rowCount={TotalRecords}
                getRowId={row => row.DHCId}
                // loading={this.props.TryingGetData}
                paginationMode="server"
                paginationModel={{ page: PageNo, pageSize: PageSize }}
                onPaginationModelChange={this.onUpdatePaginationModel}
                pageSizeOptions={pageSizeOptions}
                sortingMode={SortingMode}
                onSortModelChange={this.onSortColumns}
                sortModel={this.state.Sorting}

                onRowClick={({ row }) => this.onClickDHC({ row })}
            />
        );
    }

    render() {
        return (
            <>
                <Typography variant="h4" gutterBottom>
                    All health counselors
                </Typography>

                <Box sx={{ height: 20 }} />

                {
                    this.props.TryingGetData &&
                    <Backdrop
                        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                        open={this.props.TryingGetData}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                }

                {this.renderDatePicker()}

                <Box sx={{ height: 20 }} />

                {this.renderHealthCounselorsTable()}
            </>
        )
    }
}

const mapStateToProps = state => {
    return {
        UserDetails: state.Auth.UserDetails,

        TryingGetData: state.Regular.TryingGetData,
        TryingGetDataError: state.Regular.TryingGetDataError
    }
}

export default connect(mapStateToProps, { GetHealthCounselors })(DHCsComponent);